// lib/supabase.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Validate environment variables
if (!supabaseUrl) {
    console.error('❌ Missing REACT_APP_SUPABASE_URL environment variable');
}
if (!supabaseAnonKey) {
    console.error('❌ Missing REACT_APP_SUPABASE_ANON_KEY environment variable');
}

// Create Supabase client - REMOVE the custom fetch override
export const supabase = createClient(
    supabaseUrl,
    supabaseAnonKey,
    {
        auth: {
            persistSession: true,
            autoRefreshToken: true,
            detectSessionInUrl: true,
        },
        db: {
            schema: 'sohocard'
        }
    }
);

export default supabase;